/* RealityLink Arena — shared theme JS: live sysbar, nav, reveals, toast, money. */
(function () {
  var RL = (window.RL = window.RL || {});

  /* ---------- money (Shopify-style formatMoney) ---------- */
  RL.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || (window.RLData && window.RLData.moneyFormat) || '${{amount}}';
    function dp(num, precision, thousands, decimal) {
      precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
      thousands = thousands || ','; decimal = decimal || '.';
      var n = (cents / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsStr = parts[1] ? decimal + parts[1] : '';
      return dollars + centsStr;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case 'amount': return dp(2);
        case 'amount_no_decimals': return dp(0);
        case 'amount_with_comma_separator': return dp(2, ',', '.', ',');
        case 'amount_no_decimals_with_comma_separator': return dp(0, ',', '.', ',');
        case 'amount_with_space_separator': return dp(2, ' ', ' ', ',');
        default: return dp(2);
      }
    });
  };

  /* ---------- live status bar (ported from rl-core.js) ---------- */
  /* [open, close] in 24h decimal — Sun..Sat */
  var SCHEDULE = [[11, 20], [12, 21], [12, 21], [12, 21], [12, 21], [12, 23], [10, 23]];
  function setStatus() {
    var st = document.querySelector('[data-sys-status]');
    var dot = document.querySelector('[data-sys-dot]');
    if (!st) return;
    var now = new Date(), t = SCHEDULE[now.getDay()], h = now.getHours() + now.getMinutes() / 60;
    var status, cls;
    if (h >= t[0] && h < t[1]) { status = 'ARENA ONLINE'; cls = 'dot dot-on'; }
    else if (h >= t[0] - 1 && h < t[0]) { status = 'ARENA BOOTING-UP'; cls = 'dot dot-boot'; }
    else { status = 'ARENA OFFLINE'; cls = 'dot dot-off'; }
    st.textContent = status;
    if (dot) dot.className = cls;
  }
  setStatus();

  /* ---------- nav / mobile menu ---------- */
  var burger = document.querySelector('[data-burger]');
  if (burger) burger.addEventListener('click', function () { document.body.classList.toggle('menu-open'); });
  document.querySelectorAll('[data-mmenu] a').forEach(function (a) {
    a.addEventListener('click', function () { document.body.classList.remove('menu-open'); });
  });

  /* ---------- scroll reveals ---------- */
  RL.reveals = function () {
    var els = document.querySelectorAll('.rv:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  };
  RL.reveals();

  /* ---------- toast ---------- */
  var toastTimer = null;
  RL.toast = function (msg) {
    var t = document.querySelector('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2400);
  };

  /* ---------- escape closes overlays ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.body.classList.remove('menu-open');
      document.body.classList.remove('cart-open');
    }
  });
})();
